import { USER_OPENED_EDIT_TRIM_MODEL_CHOOSER, USER_CLOSED_EDIT_TRIM_MODEL_CHOOSER } from '../constants';

export function openTrimModelChooserAction() {
  return (dispatch) => {
    dispatch({
      type: USER_OPENED_EDIT_TRIM_MODEL_CHOOSER
    });
  }
}

export function closeTrimModelChooserAction() {
  return (dispatch) => {
    dispatch({
      type: USER_CLOSED_EDIT_TRIM_MODEL_CHOOSER
    });
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/actions/modelTrimChooser.js
 **/